import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import AXIOS from "../../../../config/api";
import { BASE_API } from "../../../../constants/apiUrls";
import { toast } from "../../../../lib/toast";
import {
  ErrorMessage,
  GetCommonData,
  Params,
  PostRequest,
} from "../../../../types";
import { GetGalleryData } from "../../../../types/webCms/gallery";

// get all
export const getAllGalleryAsync = createAsyncThunk<
  GetCommonData<GetGalleryData>,
  Params<any>,
  {
    rejectValue: ErrorMessage;
  }
>("admin/getAllGallery", async ({ params }, { rejectWithValue }) => {
  try {
    const data = await AXIOS.get(BASE_API.getHomeGallery);

    return {
      data: data?.data?.data,
      length: data.data?.totalCount,
    };
  } catch (err) {
    const errors = err as AxiosError;
    const error = errors.response?.data as ErrorMessage;
    toast("error", error?.message || "Get Gallery fail");
    return rejectWithValue(error);
  }
});

// update
export const updateGalleryAsync = createAsyncThunk<
  null,
  PostRequest<GetGalleryData, any>
>(
  "admin/updateGallery",
  async ({ data, others: { reRender } }, { rejectWithValue }) => {
    try {
      await AXIOS.patch(`${BASE_API.updateHomeGallery}`, data);

      reRender && reRender(true);
      toast("success", "Gallery update successfully");
      return null;
    } catch (err) {
      const errors = err as AxiosError;
      const error = errors.response?.data as ErrorMessage;
      toast("error", error?.message || "Gallery update fail");
      return rejectWithValue(error);
    }
  }
);
